import { createTheme } from '@mui/material/styles';
import * as React from 'react';

import accordionListStyle from 'components/AccordionList/styles';
import { overrides as accordionListOverrides } from 'components/AccordionList/styles';
import beachFlagChartStyle from 'components/BeachFlagChart/styles';
import { overrides as beachFlagChartOverrides } from 'components/BeachFlagChart/styles';
import blogCardStyle from 'components/BlogCard/styles';
import { overrides as blogCardOverrides } from 'components/BlogCard/styles';
import callOutStyle from 'components/CallOut/styles';
import { overrides as callOutOverrides } from 'components/CallOut/styles';
import callToActionStyle from 'components/CallToAction/styles';
import { overrides as callToActionOverrides } from 'components/CallToAction/styles';
import cardSliderStyle from 'components/CardSlider/styles';
import { overrides as cardSliderOverrides } from 'components/CardSlider/styles';
import chatStyle from 'components/Chat/styles';
import { overrides as chatOverrides } from 'components/Chat/styles';
import citiesMapStyle from 'components/CitiesMap/styles';
import { overrides as citiesMapOverrides } from 'components/CitiesMap/styles';
import comparisonCardBlockStyle from 'components/ComparisonCardBlock/styles';
import { overrides as comparisonCardBlockOverrides } from 'components/ComparisonCardBlock/styles';
import comparisonCardsContentLinkStyle from 'components/ComparisonCardsContentLink/styles';
import { overrides as comparisonCardsContentLinkOverrides } from 'components/ComparisonCardsContentLink/styles';
import crowdRiffStyle from 'components/CrowdRiff/styles';
import { overrides as crowdRiffOverrides } from 'components/CrowdRiff/styles';
import curatedListStyle from 'components/CuratedList/styles';
import { overrides as curatedListOverrides } from 'components/CuratedList/styles';
import curatedListCardSliderStyle from 'components/CuratedListCardSlider/styles';
import { overrides as curatedListCardSliderOverrides } from 'components/CuratedListCardSlider/styles';
import eventCardStyle from 'components/EventCard/styles';
import { overrides as eventCardOverrides } from 'components/EventCard/styles';
import eventSubmissionFormStyle from 'components/EventSubmissionForm/styles';
import { overrides as eventSubmissionFormOverrides } from 'components/EventSubmissionForm/styles';
import featureCardStyle from 'components/FeatureCard/styles';
import { overrides as featureCardOverrides } from 'components/FeatureCard/styles';
import filterSetStyle from 'components/FilterSet/styles';
import { overrides as filterSetOverrides } from 'components/FilterSet/styles';
import footerStyle from 'components/Footer/styles';
import { overrides as footerOverrides } from 'components/Footer/styles';
import imageSliderStyle from 'components/ImageSlider/styles';
import { overrides as imageSliderOverrides } from 'components/ImageSlider/styles';
import longArrowButtonStyle from 'components/LongArrowButton/styles';
import { overrides as longArrowButtonOverrides } from 'components/LongArrowButton/styles';
import mastheadStyle from 'components/Masthead/styles';
import { overrides as mastheadOverrides } from 'components/Masthead/styles';
import multiCTACardStyle from 'components/MultiCTACard/styles';
import { overrides as multiCTACardOverrides } from 'components/MultiCTACard/styles';
import navStyle from 'components/Navigation/styles';
import { overrides as navOverrides } from 'components/Navigation/styles';
import neighborhoodsMapStyle from 'components/NeighborhoodsMap/styles';
import { overrides as neighborhoodsMapOverrides } from 'components/NeighborhoodsMap/styles';
import pageAttribsStyle from 'components/PageAttribs/styles';
import { overrides as pageAttribsOverrides } from 'components/PageAttribs/styles';
import paginationStyle from 'components/Pagination/styles';
import { overrides as paginationOverrides } from 'components/Pagination/styles';
import simpleCardStyle from 'components/SimpleCard/styles';
import { overrides as simpleCardOverrides } from 'components/SimpleCard/styles';
import textSliderStyle from 'components/TextSlider/styles';
import { overrides as textSliderOverrides } from 'components/TextSlider/styles';
import threeCardLayoutStyle from 'components/ThreeCardLayout/styles';
import { overrides as threeCardLayoutOverrides } from 'components/ThreeCardLayout/styles';
import threshold360Style from 'components/Threshold360/styles';
import { overrides as threshold360Overrides } from 'components/Threshold360/styles';
import verticalTextThreeSlidesStyle from 'components/VerticalTextThreeSlides/styles';
import { overrides as verticalTextThreeSlidesOverrides } from 'components/VerticalTextThreeSlides/styles';
import { ReactComponent as Chevron } from 'images/icons/chevron.svg';
import bgTexture from 'images/sand.webp';
import beachAccessStyle from 'templates/BeachAccess/styles';
import { overrides as beachAccessOverrides } from 'templates/BeachAccess/styles';
import neighborhoodDetailsStyle from 'templates/BeachNeighborhoodGet/styles';
import { overrides as neighborhoodDetailsOverrides } from 'templates/BeachNeighborhoodGet/styles';
import blogGetStyle from 'templates/BlogPostGet/styles';
import { overrides as blogGetOverrides } from 'templates/BlogPostGet/styles';
import blogListingStyle from 'templates/BlogPostList/styles';
import { overrides as blogListingOverrides } from 'templates/BlogPostList/styles'
import eventsCategoryListStyle from 'templates/EventsCategoryList/styles';
import { overrides as eventsCategoryListOverrides } from 'templates/EventsCategoryList/styles';
import eventGetStyle from 'templates/EventsEventGet/styles';
import { overrides as eventGetOverrides } from 'templates/EventsEventGet/styles';
import listingDetailsStyle from 'templates/SimpleviewListingGet/styles';
import { overrides as listingDetailsOverrides } from 'templates/SimpleviewListingGet/styles';
import listingListStyle from 'templates/SimpleviewListingList/styles';
import { overrides as listingListOverrides } from 'templates/SimpleviewListingList/styles';

import breakpoints from './breakpoints';
import { colors, getColor } from './colors';
import mergeDeep from './mergeDeep';
import mixins from './mixins';
import { remCalc } from './remCalc';
import { typography } from './typography';

const componentStyles = mergeDeep(
	(accordionListStyle?.components ? accordionListStyle : {}),
	(navStyle?.components ? navStyle : {}),
	(navStyle || {}),
	(mastheadStyle?.components ? mastheadStyle : {}),
	(mastheadStyle || {}),
	(footerStyle?.components ? footerStyle : {}),
	(footerStyle || {}),
	(imageSliderStyle?.components ? imageSliderStyle : {}),
	(imageSliderStyle || {}),
	(citiesMapStyle?.components ? citiesMapStyle : {}),
	(citiesMapStyle || {}),
	(neighborhoodsMapStyle?.components ? neighborhoodsMapStyle : {}),
	(neighborhoodsMapStyle || {}),
	(pageAttribsStyle?.components ? pageAttribsStyle : {}),
	(pageAttribsStyle || {}),
	(paginationStyle?.components ? paginationStyle : {}),
	(paginationStyle || {}),
	(verticalTextThreeSlidesStyle?.components ? verticalTextThreeSlidesStyle : {}),
	(verticalTextThreeSlidesStyle || {}),
	(callToActionStyle?.components ? callToActionStyle : {}),
	(callToActionStyle || {}),
	(cardSliderStyle?.components ? cardSliderStyle : {}),
	(cardSliderStyle || {}),
	(comparisonCardsContentLinkStyle?.components ? comparisonCardsContentLinkStyle : {}),
	(comparisonCardsContentLinkStyle || {}),
	(listingDetailsStyle?.components ? listingDetailsStyle : {}),
	(listingDetailsStyle || {}),
	(threshold360Style?.components ? threshold360Style : {}),
	(threshold360Style || {}),
	(longArrowButtonStyle?.components ? longArrowButtonStyle : {}),
	(longArrowButtonStyle || {}),
	(filterSetStyle?.components ? filterSetStyle : {}),
	(filterSetStyle || {}),
	(blogCardStyle?.components ? blogCardStyle : {}),
	(blogCardStyle || {}),
	(blogListingStyle?.components ? blogListingStyle : {}),
	(blogListingStyle || {}),
	(blogGetStyle?.components ? blogGetStyle : {}),
	(blogGetStyle || {}),
	(threeCardLayoutStyle?.components ? threeCardLayoutStyle : {}),
	(threeCardLayoutStyle || {}),
	(neighborhoodDetailsStyle?.components ? neighborhoodDetailsStyle : {}),
	(neighborhoodDetailsStyle || {}),
	(textSliderStyle?.components ? textSliderStyle : {}),
	(textSliderStyle || {}),
	(crowdRiffStyle?.components ? crowdRiffStyle : {}),
	(crowdRiffStyle || {}),
	(multiCTACardStyle?.components ? multiCTACardStyle : {}),
	(multiCTACardStyle || {}),
	(comparisonCardBlockStyle?.components ? comparisonCardBlockStyle : {}),
	(comparisonCardBlockStyle || {}),
	(curatedListCardSliderStyle?.components ? curatedListCardSliderStyle : {}),
	(curatedListCardSliderStyle || {}),
	(curatedListStyle?.components ? curatedListStyle : {}),
	(curatedListStyle || {}),
	(chatStyle?.components ? chatStyle : {}),
	(chatStyle || {}),
	(eventSubmissionFormStyle?.components ? eventSubmissionFormStyle : {}),
	(eventSubmissionFormStyle || {}),
	(eventGetStyle?.components ? eventGetStyle : {}),
	(eventGetStyle || {}),
	(listingListStyle?.components ? listingListStyle : {}),
	(listingListStyle || {}),
	(simpleCardStyle?.components ? simpleCardStyle : {}),
	(simpleCardStyle || {}),
	(eventsCategoryListStyle?.components ? eventsCategoryListStyle : {}),
	(eventsCategoryListStyle || {}),
	(featureCardStyle?.components ? featureCardStyle : {}),
	(featureCardStyle || {}),
	(eventCardStyle?.components ? eventCardStyle : {}),
	(eventCardStyle || {}),
	(callOutStyle?.components ? callOutStyle : {}),
	(callOutStyle || {}),
	(beachAccessStyle?.components ? beachAccessStyle : {}),
	(beachAccessStyle || {}),
	(beachFlagChartStyle?.components ? beachFlagChartStyle : {}),
	(beachFlagChartStyle || {}),
);

const styleOverrides = mergeDeep(
	(accordionListOverrides || {}),
	(navStyle?.components ? {} : navStyle || {}),
	(navOverrides || {}),
	(mastheadStyle?.components ? {} : mastheadStyle || {}),
	(mastheadOverrides || {}),
	(footerStyle?.components ? {} : footerStyle || {}),
	(footerOverrides || {}),
	(imageSliderStyle?.components ? {} : imageSliderStyle || {}),
	(imageSliderOverrides || {}),
	(citiesMapStyle?.components ? {} : citiesMapStyle || {}),
	(citiesMapOverrides || {}),
	(neighborhoodsMapStyle?.components ? {} : neighborhoodsMapStyle || {}),
	(neighborhoodsMapOverrides || {}),
	(pageAttribsStyle?.components ? {} : pageAttribsStyle || {}),
	(pageAttribsOverrides || {}),
	(paginationStyle?.components ? {} : paginationStyle || {}),
	(paginationOverrides || {}),
	(verticalTextThreeSlidesStyle?.components ? {} : verticalTextThreeSlidesStyle || {}),
	(verticalTextThreeSlidesOverrides || {}),
	(callToActionStyle?.components ? {} : callToActionStyle || {}),
	(callToActionOverrides || {}),
	(cardSliderStyle?.components ? {} : cardSliderStyle || {}),
	(cardSliderOverrides || {}),
	(comparisonCardsContentLinkStyle?.components ? {} : comparisonCardsContentLinkStyle || {}),
	(comparisonCardsContentLinkOverrides || {}),
	(listingDetailsStyle?.components ? {} : listingDetailsStyle || {}),
	(listingDetailsOverrides || {}),
	(threshold360Style?.components ? {} : threshold360Style || {}),
	(threshold360Overrides || {}),
	(longArrowButtonStyle?.components ? {} : longArrowButtonStyle || {}),
	(longArrowButtonOverrides || {}),
	(filterSetStyle?.components ? {} : filterSetStyle || {}),
	(filterSetOverrides || {}),
	(blogCardStyle?.components ? {} : blogCardStyle || {}),
	(blogCardOverrides || {}),
	(blogListingStyle?.components ? {} : blogListingStyle || {}),
	(blogListingOverrides || {}),
	(blogGetStyle?.components ? {} : blogGetStyle || {}),
	(blogGetOverrides || {}),
	(threeCardLayoutStyle?.components ? {} : threeCardLayoutStyle || {}),
	(threeCardLayoutOverrides || {}),
	(neighborhoodDetailsStyle?.components ? {} : neighborhoodDetailsStyle || {}),
	(neighborhoodDetailsOverrides || {}),
	(textSliderStyle?.components ? {} : textSliderStyle || {}),
	(textSliderOverrides || {}),
	(crowdRiffStyle?.components ? {} : crowdRiffStyle || {}),
	(crowdRiffOverrides || {}),
	(multiCTACardStyle?.components ? {} : multiCTACardStyle || {}),
	(multiCTACardOverrides || {}),
	(comparisonCardBlockStyle?.components ? {} : comparisonCardBlockStyle || {}),
	(comparisonCardBlockOverrides || {}),
	(curatedListCardSliderStyle?.components ? {} : curatedListCardSliderStyle || {}),
	(curatedListCardSliderOverrides || {}),
	(curatedListStyle?.components ? {} : curatedListStyle || {}),
	(curatedListOverrides || {}),
	(chatStyle?.components ? {} : chatStyle || {}),
	(chatOverrides || {}),
	(eventSubmissionFormStyle?.components ? {} : eventSubmissionFormStyle || {}),
	(eventSubmissionFormOverrides || {}),
	(eventGetStyle?.components ? {} : eventGetStyle || {}),
	(eventGetOverrides || {}),
	(listingListStyle?.components ? {} : listingListStyle || {}),
	(listingListOverrides || {}),
	(simpleCardStyle?.components ? {} : simpleCardStyle || {}),
	(simpleCardOverrides || {}),
	(eventsCategoryListStyle?.components ? {} : eventsCategoryListStyle || {}),
	(eventsCategoryListOverrides || {}),
	(featureCardStyle?.components ? {} : featureCardStyle || {}),
	(featureCardOverrides || {}),
	(eventCardStyle?.components ? {} : eventCardStyle || {}),
	(eventCardOverrides || {}),
	(callOutStyle?.components ? {} : callOutStyle || {}),
	(callOutOverrides || {}),
	(beachAccessStyle?.components ? {} : beachAccessStyle || {}),
	(beachAccessOverrides || {}),
	(beachFlagChartStyle?.components ? {} : beachFlagChartStyle || {}),
	(beachFlagChartOverrides || {}),
);

const bgTextColorGroups = [
	{
		backgrounds: [['white'], ['blue', 100], ['ivory', 400]],
		text: getColor('ivory', 700),
		hover: getColor('ivory', 800),
	},
	{
		backgrounds: [
			['blue', 200],
			['ivory', 500],
			['blue', 400],
			['blue', 500],
			['blue', 600],
			['ivory', 600],
			['ivory', 700],
			['ivory', 800],
		],
		text: getColor('white'),
		hover: getColor('ivory', 400),
	},
];

const bgTextColorMap = Object.fromEntries(
	bgTextColorGroups.flatMap(({ backgrounds, text, hover }) =>
		backgrounds.map(([color, shade]) => [
			getColor(color, shade),
			{ text, hover },
		]),
	),
);

const writeBackgroundClasses = (keys = ['blue', 'ivory', 'white']) => {
	const classes = {};
	for (let key of keys) {
		if (colors[key] === undefined) continue;
		for (let shade in colors[key]) {
			classes[`.bg_${key}_${shade}`] = {
				backgroundColor: `${colors[key][shade]} !important`,
				'&:is(a)': {
					transition: 'color var(--transition-duration) var(--transition-timing)',
					color: `${bgTextColorMap[colors[key][shade]]?.text || 'inherit'} !important`,
					'&:hover': {
						color: `${bgTextColorMap[colors[key][shade]]?.hover || 'inherit'} !important`,
					},
				},
			}
		}
	}
	return classes;
}

const theme = createTheme(mergeDeep({
	cssVariables: true,
	breakpoints: breakpoints,
	spacing: (factor) => {
		const values = [15, 15, 15, 30, 30, 30, 45, 45, 45];
		return values[factor] || values[values.length - 1];
	},
	...typography,
	palette: colors,
	mixins: mixins,
	zIndex: {
		mobileStepper: 1000,
		fab: 1050,
		speedDial: 1050,
		appBar: 1100,
		drawer: 1200,
		snackbar: 1400,
		tooltip: 1500,
		navBar: 1600,
		backdrop: 1800,
		modal: 2000,
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: (theme) => {
				return {
					':root': {
						// Layout Variables
						'--space-lr': remCalc(theme.spacing(2)),
						'--space-gap': remCalc(theme.spacing(2)),
						'--row-max-width': `min(calc(${remCalc(theme.breakpoints.values.xl)} - (${remCalc(theme.spacing(4))} * 2)), calc(100vw - (${remCalc(theme.spacing(4))})))`,
						'--row-max-width-full': `calc(100vw - (${remCalc(theme.spacing(4))}))`,
						'--col-count': 12,
						[theme.breakpoints.up('sm')]: {
							'--row-max-width': `min(calc(${remCalc(theme.breakpoints.values.xl)} - (${remCalc(theme.spacing(4))} * 2)), calc(100vw - (${remCalc(theme.spacing(4))} * 2)))`,
							'--row-max-width-full': `calc(100vw - (${remCalc(theme.spacing(4))} * 2))`,
						},
						// Fluid Grid CSS Variables END

						'--color-primary': getColor('ivory', 700),
						'--color-secondary': getColor('ivory', 600),
						'--color-contrast': getColor('ivory', 800),
						'--color-accent': getColor('blue', 400),
						'--color-background': getColor('ivory', 400),
						'--color-map-asset': getColor('ivory', 500),
						'--font-brandon-grotesque': 'brandon-grotesque, sans-serif',
						'--font-avenir-next': 'avenir-next-lt-pro, sans-serif',
						'--heading-font': 'var(--font-brandon-grotesque)',
						'--body-font': 'var(--font-avenir-next)',
						'--transition-duration': '400ms',
						'--transition-duration-slow': '1300ms',
						'--transition-duration-fast': '.2s',
						'--transition-timing': 'ease-in-out',
						'--spacerNormal': remCalc(80),
						'--spacerLarge': remCalc(160),

						'html,body': {
							backgroundColor: 'var(--color-background)',
							color: 'var(--color-primary)',
							overflowX: 'clip',
							backgroundImage: `url(${bgTexture})`,
							backgroundPosition: 'center',
							backgroundSize: 'inherit',
							backgroundRepeat: 'repeat',
							backgroundAttachment: 'fixed',

							'&.locked': {
								overflowY: 'hidden',
							},
						},
						// a: {
						// 	...typography?.typography?.link,
						// },
						...styleOverrides,
						'.spacerNormal': {
							display: 'block',
							height: 'var(--spacerNormal)',
						},
						'.spacerLarge': {
							display: 'block',
							height: 'var(--spacerLarge)',
						},
						'.uppercase': {
							textTransform: 'uppercase',
						},
						'.grecaptcha-badge': {
							transform: 'scale(0)',
							visibility: 'hidden',
						},
						'.VideoEmbed-root': {
							iframe: {
								width: '100%',
								height: 'auto',
								maxHeight: 'calc(100% - 80px)',
								border: 0,
								aspectRatio: '16/9',
							},
						},
						'.responsive-embed': {
							position: 'relative',
							height: 0,
							marginBottom: '1rem',
							paddingBottom: '75%',
							overflow: 'hidden',
							'&.widescreen': {
								paddingBottom: '56.25%',
							},
							'iframe': {
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
							}
						},
						hr: {
							appearance: 'none',
							width: '100%',
							height: remCalc(1),
							background: getColor('ivory', 600),
							opacity: .5,
							padding: 0,
							margin: remCalc('15 0'),
						},
						'@media (prefers-reduced-motion: reduce)': {
							'*': {
								transition: 'none !important',
							}
						},
					},
					'p, .content__mimic': {
						...typography?.typography?.body1,
						marginBlockStart: remCalc(16),
						marginBlockEnd: remCalc(16),
					},
					...writeBackgroundClasses(),
				};
			}
		},
		MuiLink: {
			// defaultProps: {
			// 	component: Link,
			// },
			styleOverrides: {
				root: typography?.typography?.link,
			},
			variants: [
				{
					props: { variant: 'button' },
					style: {
						...mixins.button,
					}
				},
				{
					props: { variant: 'small' },
					style: {
						...mixins.button_small,
					}
				},
				{
					props: { variant: 'bold_arrow' },
					style: {
						...mixins.bold_arrow,
					}
				}
				// {
				// 	props: { variant: 'arrowButton' },
				// 	component: Button,
				// 	style: {
				// 		...mixins.button,
				// 		textTransform: 'uppercase',
				// 	}
				// },
			],
			// ...typography?.typography?.link, 
		},
		MuiButton: {
			defaultProps: {
				// component: Link,
				variant: 'naked',
			},
			variants: [
				{
					props: { variant: 'naked' },
					style: {
						...mixins.button,
					}
				},
				{
					props: { variant: 'small' },
					style: {
						...mixins.button_small,
					}
				},
				{
					props: { variant: 'outlined' },
					style: {
						...mixins.button_outlined,
					}
				},
				{
					props: { variant: 'underlined' },
					style: {
						...mixins.button_underlined,
					}
				},
				{
					props: { variant: 'icon' },
					style: {
						color: getColor('ivory', 800),
						height: remCalc(60),
						svg: {
							width: remCalc(24),
						},
						'&:hover': {
							background: 'white',
						},
					}
				},
				{
					props: { variant: 'dialog-dark' },
					style: {
						...mixins.button_dialog_dark,
					}
				},
				{
					props: { variant: 'dialog-light' },
					style: {
						...mixins.button_dialog_light,
					}
				},
			],
		},
		MuiContainer: {
			defaultProps: {
				maxWidth: 'xl',
			},
		},
		MuiBackdrop: {
			styleOverrides: {
				root: {
					zIndex: 'var(--mui-zIndex-backdrop)',
					background: 'rgba(66, 59, 61, 0.70)',
				}
			}
		},
		MuiDialog: {
			variants: [
				{
					props: { variant: 'dialog' },
					style: {
						'.MuiDialog-paper': {
							maxWidth: '1268px',
							width: '100%',
							height: 'calc(100% - 150px)',
							background: 'transparent',
							borderRadius: 0,
							'.Dialog-titleBar': {
								display: 'flex',
								backgroundColor: getColor('ivory', 400),
								color: getColor('ivory', 700),
								gap: '10px',
								padding: remCalc('3 40'),
								alignItems: 'center',
								justifyContent: 'space-between',

								'.Dialog-titleButtonRow': {
									display: 'flex',
									gap: '10px',
									alignItems: 'center',
									justifyContent: 'flex-end',
								},

								'.MuiDialogTitle-root': {
									position: 'relative',
									...typography?.typography?.h3,
								},
							},
							'.MuiDialogContent-root': {
								...mixins.glass,
								backgroundColor: 'rgba(255, 255, 255, .25)',
								padding: remCalc('40'),
								p: {
									...typography?.typography?.body1,
								},
								'.MuiDialogContentText-root': {
									color: 'white',
								},
							},
							'.MuiDialogActions-root': {
								position: 'absolute',
								width: '100%',
								bottom: 0,
								left: 0,
								padding: remCalc('20 40'),
								background: 'rgba(255, 255, 255, .35)',
								...mixins.glass,
								color: 'white',
								gap: '20px',
								whiteSpace: 'nowrap',

								'.MuiButton-root': {
									// color: 'white',
									// borderColor: 'white',
									padding: remCalc(20),
								},

								'.MuiInputBase-root': {
									// color: 'white',
								}
							},
						}
					}
				},

				{
					props: { variant: 'prompt' },
					style: {
						'.MuiDialog-paper': {
							maxWidth: '974px',
							width: '100%',
							maxHeight: 'calc(100% - 250px)',
							background: 'transparent',
							borderRadius: 0,
							...mixins.glass,
							backgroundColor: 'rgba(255, 255, 255, .25)',
							padding: remCalc('10 40 40 40'),
							color: 'white',
							'.Prompt-closeButton': {
								color: 'white',
								position: 'absolute',
								right: 0,
								top: 0,
								transition: 'all var(--transition-duration)',
								'&:hover': {
									background: 'transparent',
									color: getColor('ivory', 800),
								}
							},
							'.Prompt-titleBar': {
								padding: 0,
								'.MuiDialogTitle-root': {
									position: 'relative',
									textAlign: 'center',
									textTransform: 'uppercase',
									...typography?.typography?.h2,
								},
							},
							'.MuiDialogContentText-root': {
								color: 'white',
								'.MuiButton-root': {
									padding: remCalc(20),
								},
								'*': {
									color: 'white',
									borderColor: 'white',
								},
							}
						}
					},
				},
			],
		},

		MuiAccordion: {
			defaultProps: {
				elevation: 0,
				square: true,
				slotProps: {
					heading: {
						component: 'h4',
					},
				},
			},
			styleOverrides: {
				root: {
					backgroundColor: 'transparent',
					'&::before': {
						display: 'none'
					},
					borderBottom: `1px solid ${getColor('ivory', 500)}`,

					'.MuiAccordion-heading': {
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: remCalc(20),
						cursor: 'pointer',
						color: getColor('ivory', 700),
						'&:focus-visible': {
							outline: `2px solid ${getColor('ivory', 400)}`,
							outlineOffset: remCalc(4),
						},
						h4: {
							fontWeight: 400,
						},
					}
				}
			},
		},
		MuiAccordionSummary: {
			defaultProps: {
				expandIcon: <Chevron className="MuiAccordionSummary-icon" aria-hidden="true" />,
			},
			styleOverrides: {
				root: {
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: remCalc(20),
					cursor: 'pointer',
					padding: remCalc('64 0'),
					color: getColor('ivory', 700),
					'&:focus-visible': {
						outline: `2px solid ${getColor('ivory', 400)}`,
						outlineOffset: remCalc(4),
					},

					'.MuiAccordionSummary-content.Mui-expanded': {
						margin: remCalc('12 0'),
					},

					'.MuiAccordionSummary-expandIconWrapper': {
						color: getColor('ivory', 600),
						transform: 'none',
						transition: 'none',
						'&.Mui-expanded .MuiAccordionSummary-icon': {
							transform: 'rotate(-90deg)',
						},
						'.MuiAccordionSummary-icon': {
							position: 'relative',
							flex: `0 0 ${remCalc(18)}`,
							width: remCalc(18),
							height: remCalc(18),
							transition: 'transform var(--transition-duration) ease-in-out',
							transform: 'rotate(90deg)',
						},
					},
				},
			},
		},
		MuiAccordionDetails: {
			styleOverrides: {
				root: {
					padding: remCalc('0 20 20 20'),
					color: getColor('ivory', 700),
				},
			},
		},
	},
}), componentStyles);

export default theme;